<script setup>
import mainLogo from "@images/brand/alomonshi-symbol.png"
import supportSvg from "@images/headphones4.svg"
import { defineEmits, computed } from "vue"

const emits = defineEmits(["register"])
const route = useRoute()
const router = useRouter()
const store = useNavigationStore()
const authDialog = ref(false)
const isOtpShow = ref(false)

const isRegisterBtnShow = computed(() => {
  return route.name === "main" || route.name === "user-profile"
})

const previousPage = computed(() => {
  return store.previousRoute
})

const onClick = () => {
  emits("register")
}

const goBack = () => {
  if (previousPage.value) {
    navigateTo(previousPage.value)
  }
}
</script>

<template>
  <VCard class="pr-4 pl-5 py-3">
    <div class="d-flex align-center justify-space-between">
      <button v-if="previousPage" @click="goBack">
        <VIcon size="30" color="#000" icon="tabler-arrow-right" />
      </button>
      <VImg v-else :src="mainLogo" alt="لوگوی الومنشی" :max-width="54" />
      <div class="d-flex">
        <VBtn
          v-if="isRegisterBtnShow"
          prepend-icon="tabler-building-store"
          color="primary"
          class="text-sm"
          @click="onClick"
        >
          ثبت شرکت
        </VBtn>
        <VImg :src="supportSvg" alt="Coming Soon" width="22" class="mr-4" />
      </div>
    </div>
  </VCard>
</template>

<style lang="scss" scoped>
//
</style>
